import EventDispatcher from '@/core/event/eventDispatcher';
import ViewEvent from '@/core/event/viewEvent';
import LogUtil from '@/core/utils/logUtil';
import ViewportEvent from '@/core/utils/viewport/viewportEvents';
import Sharer from '../components/navigation/sharer';
import AppStateModel from '@/app/model/appStateModel';
import type NavigationBar from "@/app/components/navigation/navigationBar";

export default class MainController {

    public static navigationBar:NavigationBar;

    constructor(navigation) {
        MainController.navigationBar = navigation;
        EventDispatcher.addEventListener(ViewEvent.START_LOADING, (event) => this.onViewEvent(event));
        EventDispatcher.addEventListener(ViewEvent.CHANGED, (event) => this.onViewEvent(event));

        EventDispatcher.addEventListener(ViewportEvent.BREAKPOINT_CHANGE, (event) => this.breakPointChange(event));
    }

    breakPointChange(event) {
        LogUtil.log(event);
    }

    onViewEvent(event) {
        LogUtil.logClass(this, event.type, event.data);

        if(event.type == ViewEvent.START_LOADING) {
            MainController.navigationBar.enabled = false;
        }
        if(event.type == ViewEvent.CHANGED) {
            MainController.navigationBar.enabled = true;
            MainController.navigationBar.currentNavItem = event.data.id;
            AppStateModel.currentViewID = event.data.id;
        }
    }

    static setSharing(boolean = false) {

        Sharer.isActive = boolean;


        if(boolean) {
            MainController.navigationBar.showShareButtons();
        } else {
            MainController.navigationBar.hideShareButtons();
        }
    }
}
